import { render, staticRenderFns } from "./webSetting.vue?vue&type=template&id=7895a394&scoped=true&"
import script from "./webSetting.vue?vue&type=script&lang=js&"
export * from "./webSetting.vue?vue&type=script&lang=js&"
import style1 from "./webSetting.vue?vue&type=style&index=1&id=7895a394&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7895a394",
  null
  
)

export default component.exports